  <form [formGroup]="form" class="form">
    <kendo-gridlayout [rows]="[{height:35},{height:35},{height:40},{height:35}]"
                      [cols]="[{width:190},{width:310}]"
                      [gap]="{rows:1, cols:10}">
      <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
        <kendo-label>Organization*</kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
        <app-select-field [control]="organizationSelect"></app-select-field>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </form>

  <div class="submitSection">
    <div class="submitSection">
      <button kendoButton class="btnSave" [disabled]="!form.valid" (click)="save()">
        @if (saving){
        <kendo-loader type="pulsing" size="medium" themeColor="warning"></kendo-loader>
        } @else {
        <span id="iconContainer" style="display:block;float:left"><fa-icon #icon [icon]="saveIcon"></fa-icon></span>
        }
        &nbsp;&nbsp;
        Save
      </button>
    </div>
  </div>
